<template>
  <div id="app">
    <header :class="{ 'mobile-hidden': isMobile && currentRoute !== 'navigation' }">
      <div class="logo">
        <img src="@/assets/ic_launcher.png" alt="PDF随身工具箱" />
      </div>
      <nav v-if="!isMobile">
        <ul>
          <li><a href="#" @click.prevent="navigate('home')">首页</a></li>
          <li><a href="#" @click.prevent="navigate('intro')">介绍</a></li>
          <li><a href="#" @click.prevent="navigate('about')">关于</a></li>
          <li><a href="#" @click.prevent="navigate('contact')">联系我们</a></li>
          <li><a href="https://developer.pdf.foxhank.top" target="_blank" @click="toggleMenu()">开发者控制台</a></li>
          <li><a href="https://docs.pdf.foxhank.top" target="_blank" @click="toggleMenu()">接入文档</a></li>
        </ul>
      </nav>
      <div v-else class="menu-button" @click="toggleMenu">
        <div class="menu-icon">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </header>

    <div v-if="isMobile && showMobileMenu" class="mobile-menu">
      <ul>
        <li><a href="#" @click.prevent="navigate('home'); toggleMenu()">首页</a></li>
        <li><a href="#" @click.prevent="navigate('translate'); toggleMenu()">介绍</a></li>
        <li><a href="#" @click.prevent="navigate('about'); toggleMenu()">关于</a></li>
        <li><a href="#" @click.prevent="navigate('contact'); toggleMenu()">联系我们</a></li>
        <li><a href="https://developer.pdf.foxhank.top" target="_blank" @click="toggleMenu()">开发者控制台</a></li>
        <li><a href="https://docs.pdf.foxhank.top" target="_blank" @click="toggleMenu()">接入文档</a></li>
      </ul>
    </div>

    <main>
      <div class="page-container" @wheel.prevent="handleScroll" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
        <section :class="['page', { active: currentRoute === 'home' }]" id="home">
          <div class="home-content">
            <img src="@/assets/ic_launcher.png" alt="PDF随身工具箱" class="home-logo" />
            <h1>PDF随身工具箱</h1>
            <p class="subtitle">随身，便捷的PDF处理帮手</p>
            <a href="#" @click.prevent="navigate('download')" class="download-button">下载应用</a>
          </div>
        </section>

        <section :class="['page', { active: currentRoute === 'translate' }]" id="translate">
          <div class="feature-container">
            <div class="feature">
              <div class="feature-text">
                <h2>智能翻译，轻松阅读</h2>
                <p>支持多语言PDF文档实时翻译，告别语言障碍，让全球资讯触手可及。专业术语精准对应，学术文献轻松理解。</p>
              </div>
              <div class="feature-image">
                <img src="@/assets/screenshot-translate.png" alt="PDF翻译功能" />
              </div>
            </div>
          </div>
        </section>

        <section :class="['page', { active: currentRoute === 'convert' }]" id="convert">
          <div class="feature-container">
            <div class="feature">
              <div class="feature-text">
                <h2>灵活转换，多种格式</h2>
                <p>一键将PDF转换为Word、Excel、图片等多种格式，保持原始排版和样式，让文档编辑与分享更加便捷。</p>
              </div>
              <div class="feature-image">
                <img src="@/assets/screenshot-convert.png" alt="PDF转换功能" />
              </div>
            </div>
          </div>
        </section>

        <section :class="['page', { active: currentRoute === 'merge' }]" id="merge">
          <div class="feature-container">
            <div class="feature">
              <div class="feature-text">
                <h2>高效处理，智能管理</h2>
                <p>多文档智能合并，批量处理大量PDF文件，支持页面管理、水印添加、OCR识别等专业功能，满足各种复杂需求。</p>
              </div>
              <div class="feature-image">
                <img src="@/assets/screenshot-merge.png" alt="PDF合并处理功能" />
              </div>
            </div>
          </div>
        </section>

        <section :class="['page', { active: currentRoute === 'about' }]" id="about">
          <div class="feature-container">
            <div class="feature">
              <div class="feature-text">
                <h2>关于我们</h2>
                <p>PDF随身工具箱是一款专业的PDF处理工具，致力于为用户提供高效、便捷的PDF文档处理解决方案。我们的团队由一群热爱技术的专业人士组成，不断创新，为用户带来更好的产品体验。</p>
                <a href="mailto:support@pdftools.com" class="email-button">联系我们的邮箱</a>
              </div>
              <div class="feature-image">
                <img src="@/assets/about-us.png" alt="关于我们" />
              </div>
            </div>
          </div>
        </section>

        <section :class="['page', { active: currentRoute === 'contact' }]" id="contact">
          <div class="feature-container">
            <div class="feature">
              <div class="feature-text">
                <h2>联系我们</h2>
                <p>如果您有任何问题或建议，请随时与我们联系。我们将竭诚为您服务。</p>
                <div class="contact-info">
                  <p>邮箱：foxhank@aliyun.com</p>
                </div>
              </div>
              <div class="feature-image">
                <img src="@/assets/contact-us.png" alt="联系我们" />
              </div>
            </div>
          </div>
        </section>

        <section :class="['page', { active: currentRoute === 'download' }]" id="download">
          <div class="download-container">
            <h2>下载中心</h2>
            <div class="download-options">
              <div class="download-option">
                <img src="@/assets/android-icon.svg" alt="安卓版" />
                <h3>安卓端应用</h3>
                <p>适用于Android 6.0及以上系统</p>
                <a href="https://dl.foxhank.top/pdftoolbox/pdftoolbox.apk" class="download-link">下载APK</a>
              </div>

              <div class="download-option">
                <img src="@/assets/android-icon.svg" alt="苹果版" />
                <h3>IOS端应用</h3>
                <p>敬请期待</p>
                <a href="#" class="download-link-disable">APP Store</a>
              </div>

              <div class="download-option">
                <img src="@/assets/sdk-icon.svg" alt="SDK开发包" />
                <h3>开发SDK</h3>
                <p>用于集成到您自己的应用中</p>
                <div class="sdk-options">
                  <a href="#" class="download-link">安卓SDK</a>
                  <a href="https://dl.foxhank.top/pdftoolbox/pdftoolbox-1.0.0.har" class="download-link">鸿蒙SDK</a>
                </div>
              </div>
            </div>
            <div class="footer-container">
              <footer>
                <p>&copy; 2025 PDF随身工具箱 - 版权所有</p>
                <p>黑ICP备2023014951号;黑公网安备23010202010620号</p>
              </footer>
            </div>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentRoute: 'home',
      pageTitle: 'PDF随身工具箱', // 添加页面标题
      isMobile: false,
      showMobileMenu: false,
      touchStartY: 0,
      pages: ['home', 'translate', 'convert', 'merge', 'about', 'contact', 'download'],
      scrollTimeout: null,
      isScrolling: false
    };
  },
  created() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
    this.updateDocumentTitle(); // 初始加载时设置页面标题
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    navigate(route) {
      let routeTitle = 'PDF随身工具箱'; // 默认标题
      
      if (route === 'intro') {
        this.currentRoute = 'translate';
        routeTitle = '翻译 - PDF随身工具箱';
      } else {
        this.currentRoute = route;
        switch(route) {
          case 'translate':
            routeTitle = '翻译 - PDF随身工具箱';
            break;
          case 'convert':
            routeTitle = '转换 - PDF随身工具箱';
            break;
          case 'merge':
            routeTitle = '合并 - PDF随身工具箱';
            break;
          case 'about':
            routeTitle = '关于 - PDF随身工具箱';
            break;
          case 'contact':
            routeTitle = '联系我们 - PDF随身工具箱';
            break;
          case 'download':
            routeTitle = '下载 - PDF随身工具箱';
            break;
          default:
            routeTitle = 'PDF随身工具箱';
        }
      }

      document.title = routeTitle; // 更新页面标题
      this.showMobileMenu = false;
    },
    updateDocumentTitle() {
      // 根据currentRoute设置初始页面标题
      this.navigate(this.currentRoute);
    },

    handleScroll(event) {
      if (this.isScrolling) return;
      
      // 获取当前页面元素
      const currentPageElement = document.querySelector('.page.active');
      const direction = event.deltaY > 0 ? 1 : -1;
      
      // 检查当前页面是否可滚动且未到达底部/顶部
      if (currentPageElement && this.currentRoute === 'download') {
        const container = currentPageElement.querySelector('.download-container');
        if (container) {
          const isAtBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 5;
          const isAtTop = container.scrollTop <= 5;
          
          // 如果内容可滚动且未到达边界，则不进行页面切换
          if ((direction > 0 && !isAtBottom) || (direction < 0 && !isAtTop)) {
            return;
          }
        }
      }
      
      this.isScrolling = true;
      this.navigateByDirection(direction);
      
      // 防止快速连续滚动
      setTimeout(() => {
        this.isScrolling = false;
      }, 800);
    },
    handleTouchStart(event) {
      this.touchStartY = event.touches[0].clientY;
    },
    handleTouchEnd(event) {
      if (this.isScrolling) return;
      
      const touchEndY = event.changedTouches[0].clientY;
      const direction = this.touchStartY > touchEndY ? 1 : -1;

      // 获取当前页面元素
      const currentPageElement = document.querySelector('.page.active');
      
      // 检查当前页面是否可滚动且未到达底部/顶部
      if (currentPageElement && this.currentRoute === 'download') {
        const container = currentPageElement.querySelector('.download-container');
        if (container) {
          const isAtBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 5;
          const isAtTop = container.scrollTop <= 5;
          
          // 如果内容可滚动且未到达边界，则不进行页面切换
          if ((direction > 0 && !isAtBottom) || (direction < 0 && !isAtTop)) {
            return;
          }
        }
      }

      if (Math.abs(this.touchStartY - touchEndY) > 50) {
        this.isScrolling = true;
        this.navigateByDirection(direction);
        
        // 防止快速连续滑动
        setTimeout(() => {
          this.isScrolling = false;
        }, 800);
      }
    },
    navigateByDirection(direction) {
      const currentIndex = this.pages.indexOf(this.currentRoute);
      let nextIndex = currentIndex + direction;

      if (nextIndex >= 0 && nextIndex < this.pages.length) {
        this.navigate(this.pages[nextIndex]);
      }
    }
  }
};
</script>


<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  overflow: hidden;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  transition: transform 0.3s ease-in-out;
}

.logo img {
  height: 40px;
}

nav ul {
  display: flex;
  list-style: none;
}

nav ul li {
  margin-left: 2rem;
}

nav ul li a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.3s;
}

nav ul li a:hover {
  color: #4CAF50;
}

.mobile-hidden {
  transform: translateY(-100%);
  transition: transform 0.3s ease-in-out;
}

.menu-button {
  cursor: pointer;
  padding: 10px;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.menu-icon {
  width: 30px;
  height: 20px;
  position: relative;
}

.menu-icon div {
  height: 3px;
  background-color: #333;
  margin: 5px 0;
  transition: 0.3s;
}

.mobile-menu {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 99;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}

.mobile-menu ul {
  list-style: none;
}

.mobile-menu ul li {
  padding: 1rem 2rem;
  border-bottom: 1px solid #eee;
}

.mobile-menu ul li a {
  text-decoration: none;
  color: #333;
  display: block;
}

main {
  flex: 1;
  padding-top: 60px;
}

.page-container {
  height: calc(100vh - 60px);
  position: relative;
  overflow: hidden;
}

.page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
}

.page.active {
  opacity: 1;
  visibility: visible;
  z-index: 1;
}

/* Home Page */
#home {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #f9f9f9;
}

.home-content {
  max-width: 800px;
  padding: 2rem;
}

.home-logo {
  width: 120px;
  margin-bottom: 2rem;
}

h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #333;
}

.subtitle {
  font-size: 1.5rem;
  color: #666;
  margin-bottom: 2rem;
}

.download-button {
  display: inline-block;
  background-color: #4CAF50;
  color: white;
  padding: 1rem 2rem;
  text-decoration: none;
  border-radius: 30px;
  font-weight: bold;
  font-size: 1.2rem;
  transition: background-color 0.3s;
}

.download-button:hover {
  background-color: #3e8e41;
}

.email-button {
  display: inline-block;
  background-color: #2196F3;
  color: white;
  padding: 0.7rem 1.5rem;
  text-decoration: none;
  border-radius: 20px;
  margin-top: 1rem;
  font-weight: 500;
  transition: background-color 0.3s;
}

.email-button:hover {
  background-color: #0b7dda;
}

/* Features Page */
.feature-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 2rem 0;
  height: 100%;
  overflow-y: auto;
}

.feature {
  display: flex;
  align-items: center;
  margin-bottom: 5rem;
}

.feature.reverse {
  flex-direction: row-reverse;
}

.feature-text {
  flex: 1;
  padding: 0 2rem;
}

.feature-text h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #4CAF50;
}

.feature-text p {
  font-size: 1.2rem;
  color: #666;
}

.feature-image {
  flex: 1;
  text-align: center;
}

.feature-image img {
  max-width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.contact-info {
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #f1f1f1;
  border-radius: 10px;
}

.contact-info p {
  margin-bottom: 0.5rem;
}

/* Download Page */
#download {
  background-color: #f9f9f9;
}

.download-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 80px 2rem 0;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.download-container h2 {
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: #333;
}

.download-options {
  display: flex;
  justify-content: center;
  gap: 3rem;
  flex: 1;
}

.download-option {
  flex: 1;
  max-width: 300px;
  background-color: #fff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.download-option:hover {
  transform: translateY(-10px);
}

.download-option img {
  width: 80px;
  margin-bottom: 1.5rem;
}

.download-option h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.download-option p {
  color: #666;
  margin-bottom: 1.5rem;
}

.download-link {
  display: inline-block;
  background-color: #4CAF50;
  color: white;
  padding: 0.7rem 1.5rem;
  text-decoration: none;
  border-radius: 20px;
  margin: 0.5rem;
  transition: background-color 0.3s;
}

.download-link-disable {
  display: inline-block;
  background-color: #747474;
  color: white;
  padding: 0.7rem 1.5rem;
  text-decoration: none;
  border-radius: 20px;
  margin: 0.5rem;
  transition: background-color 0.3s;
}

.download-link:hover {
  background-color: #3e8e41;
}

.sdk-options {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-container {
  margin-top: auto;
  width: 100%;
}

footer {
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 1rem 0;
  width: 100%;
}

/* Responsive Styles */
@media (max-width: 768px) {
  h1 {
    font-size: 2.5rem;
  }
  
  .subtitle {
    font-size: 1.2rem;
  }
  
  .feature {
    flex-direction: column;
    margin-bottom: 3rem;
  }
  
  .feature.reverse {
    flex-direction: column;
  }
  
  .feature-text {
    order: 1;
    text-align: center;
    padding: 0;
    margin-bottom: 1.5rem;
  }
  
  .feature-image {
    order: 2;
  }
  
  .feature-text h2 {
    font-size: 2rem;
  }
  
  .feature-text p {
    font-size: 1rem;
  }
  
  .download-options {
    flex-direction: column;
    align-items: center;
  }
  
  .download-option {
    margin-bottom: 2rem;
  }
  
  .menu-button {
    right: 10px;
  }
}
</style>